/* ------------------------------------------------------------------
   SettingsLayout.js  (v3.0 – modernized UI, matches dashboard theme)
------------------------------------------------------------------ */
import React, { useEffect, useState } from 'react'
import { Offcanvas, Button } from 'react-bootstrap'
import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { List } from 'react-bootstrap-icons'

const NAV_ITEMS = [
  { to: 'account',      label: 'Account Settings', icon: 'fas fa-user-circle' },
  { to: 'subscription', label: 'Subscription',     icon: 'fas fa-credit-card' },
  { to: 'api-keys',     label: 'API Keys',          icon: 'fas fa-key' },
  { to: 'hashtags',     label: 'Hashtags',          icon: 'fas fa-hashtag' },
  { to: 'logout',       label: 'Logout',            icon: 'fas fa-sign-out-alt' },
]

const SettingsLink = ({ to, label, icon, onClick }) => (
  <NavLink
    to={to}
    end
    onClick={onClick}
    className='text-decoration-none'
    style={({ isActive }) => ({
      display    : 'flex',
      alignItems : 'center',
      gap        : 10,
      padding    : '9px 14px',
      borderRadius: 8,
      marginBottom: 2,
      fontWeight : 500,
      fontSize   : 14,
      color      : isActive ? '#2563eb' : '#6b7280',
      background : isActive ? '#eff6ff' : 'transparent',
      transition : 'all 0.15s ease',
    })}
    onMouseEnter={e => {
      if (!e.currentTarget.classList.contains('active')) {
        e.currentTarget.style.background = '#f8fafc'
        e.currentTarget.style.color = '#374151'
      }
    }}
    onMouseLeave={e => {
      if (!e.currentTarget.classList.contains('active')) {
        e.currentTarget.style.background = 'transparent'
        e.currentTarget.style.color = '#6b7280'
      }
    }}
  >
    <i className={icon} style={{ fontSize: 14, width: 16, textAlign: 'center', flexShrink: 0 }} />
    {label}
  </NavLink>
)

const SidebarBody = ({ hideHeading = false, onNavigate }) => (
  <div>
    {!hideHeading && (
      <div style={{ marginBottom: 16, paddingBottom: 14, borderBottom: '1px solid #f3f4f6' }}>
        <span style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#9ca3af' }}>
          Settings
        </span>
      </div>
    )}
    <nav style={{ display: 'flex', flexDirection: 'column' }}>
      {NAV_ITEMS.map(item => (
        <SettingsLink key={item.to} {...item} onClick={onNavigate} />
      ))}
    </nav>
  </div>
)

export default function SettingsLayout () {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])   // block form: don't return scrollTo's value (React 19 calls non-undefined returns as cleanup)

  const [showMenu, setShowMenu] = useState(false)

  return (
    <div style={{ display: 'flex', minHeight: '80vh', gap: 24 }}>

      {/* Mobile top bar */}
      <div className='d-md-none' style={{
        position  : 'fixed',
        top       : 0,
        left      : 0,
        right     : 0,
        height    : 52,
        background: '#ffffff',
        borderBottom: '1px solid #e5e7eb',
        display   : 'flex',
        alignItems: 'center',
        zIndex    : 100,
        padding   : '0 16px',
        gap       : 10,
      }}>
        <Button variant='link' style={{ color: '#374151', padding: 4 }} onClick={() => setShowMenu(true)}>
          <List size={22} />
        </Button>
        <span style={{ fontWeight: 700, fontSize: 15, color: '#111827' }}>Settings</span>
      </div>

      {/* Desktop sidebar */}
      <div className='d-none d-md-block' style={{
        width       : 210,
        minWidth    : 210,
        background  : '#ffffff',
        border      : '1px solid #e5e7eb',
        borderRadius: 12,
        padding     : '16px 12px',
        alignSelf   : 'flex-start',
        position    : 'sticky',
        top         : 24,
        boxShadow   : '0 1px 3px rgba(0,0,0,0.05)',
      }}>
        <SidebarBody />
      </div>

      {/* Mobile offcanvas */}
      <Offcanvas
        show={showMenu}
        onHide={() => setShowMenu(false)}
        className='d-md-none'
        scroll
        style={{ maxWidth: 260 }}
      >
        <Offcanvas.Header closeButton style={{ borderBottom: '1px solid #f3f4f6' }}>
          <Offcanvas.Title style={{ fontWeight: 800, fontSize: 16 }}>Settings</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className='pt-2'>
          <SidebarBody hideHeading onNavigate={() => setShowMenu(false)} />
        </Offcanvas.Body>
      </Offcanvas>

      {/* Main content */}
      <div style={{ flex: 1, minWidth: 0, paddingTop: 0 }}>
        <Outlet />
      </div>
    </div>
  )
}